var $773d5888b972f1cf$exports = {};
$773d5888b972f1cf$exports = {
    "dismiss": `\u{62A}\u{62C}\u{627}\u{647}\u{644}`
};


export {$773d5888b972f1cf$exports as default};
//# sourceMappingURL=ar-AE.module.js.map
